import { SDrawerOrModal, SLowcodeList } from 'shj-components'
import { useEffect, useRef } from 'react'
import { config } from './config.tsx'

const AddOrEditDom = ({ open, record, onClose }: any) => {
  const listRef = useRef<any>();

  useEffect(() => {
    if (open) {
      const questionnaireList = record?.questionnaireList || [];
      listRef?.current?.updateDataSource(questionnaireList);
    }
  }, [open, record]);

  const resetFn = () => {
    onClose?.();
  };

  return (
    <SDrawerOrModal
      width={1000}
      title={`查看问题详情(${record?.companyName||'-'})`}
      open={open}
      onCancel={resetFn}
      onClose={resetFn}
      destroyOnClose={true}
      isHidenOkBtn={true}
      isHideCancelBtn={true}
    >
      <SLowcodeList
        config={{
          ...config,
        }}
        scroll={{ y: 'calc(100vh - 260px)' }}
        ref={listRef}
        searchMode="group"
      />
    </SDrawerOrModal>
  );
};

export default AddOrEditDom;
